import { HttpClient, provideHttpClient } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { DpAppSwitcherService, DpErrorPagesModule, DpToastModule } from '@docpath/webcomponents';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { AppService } from './app/app.service';
import { FormGuard } from './app/shared/guards/form.guard';
import { LoginGuard } from './app/shared/guards/login.guard';
import { NotFoundGuard } from './app/shared/guards/not-found.guard';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(),

    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: () => localStorage.getItem('access_token')
        }
      }),

      DpErrorPagesModule,
      DpToastModule,

      TranslateModule.forRoot({
        fallbackLang: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      })
    ),

    // Tus providers personalizados
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: './assets/i18n/', suffix: '.json' } },
    {
      provide: 'environment',
      useFactory: (appService: AppService) => ({
        accessControlApiPath: environment.accessControlApiPath,
        appName: environment.appName,
        baseUrl: appService.getBaseUrl(),
        cookieName: environment.cookieName,
        webApiPath: environment.webApiPath,
        context: environment.context
      }),
      deps: [AppService]
    },
    { provide: 'appName', useValue: environment.appName },

    // Guards
    FormGuard,
    LoginGuard,
    NotFoundGuard,

    // Inicialización del AppSwitcherService
    provideAppInitializer(() => {
      const appService = inject(AppService);
      inject(DpAppSwitcherService);
      appService.loadConfig();
    }),

    // Inicialización de los iconos FontAwesome
    provideAppInitializer(() => {
      const library = inject(FaIconLibrary);
      library.addIconPacks(fas, far);
    })
  ]
}).catch(error => { throw error; });

export function createTranslateLoader(): TranslateHttpLoader {
  return new TranslateHttpLoader();
}